import { useCallback, useEffect, useState } from 'react';

import { addEventListener, removeEventListener } from 'Lib/utils/mediaQueryListener';

const useMediaQuery = (query: string, initialMatch: boolean = false) => {
  const [matches, setMatches] = useState(
    __CLIENT__ ? window.matchMedia(query).matches : initialMatch
  );
  const handleChange = useCallback((e) => setMatches(e.matches), []);

  useEffect(() => {
    const queryList = window.matchMedia(query);
    setMatches(queryList.matches);
    // media query mock library doesn't have addEventListener
    // use conditional statement for tree-shaking
    addEventListener(queryList, handleChange);

    return () => {
      removeEventListener(queryList, handleChange);
    };
  }, [query, handleChange]);

  return matches;
};

export default useMediaQuery;
